import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs'

export default class extends Controller {
  static targets = ['list']
  static values = {
    realEstateAdminId: Number,
  }

  connect() {
    this.initializeSortable()
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  initializeSortable() {
    if (this.hasListTarget) {
      this.sortable = Sortable.create(this.listTarget, {
        animation: 150,
        handle: '.drag-handle',
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        onEnd: this.onSortEnd.bind(this),
      })
    }
  }

  onSortEnd(event) {
    if (event.oldIndex === event.newIndex) {
      return // No change in position
    }

    // Get the new order of configuration IDs
    const configurationIds = Array.from(this.listTarget.children).map((item) => {
      return item.dataset.configurationId
    })

    // Send the new order to the server
    this.updateConfigurationOrder(configurationIds)
  }

  updateConfigurationOrder(configurationIds) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

    fetch(
      `/real_estate_admin/${this.realEstateAdminIdValue}/real_estate_admin_configuration/reorder`,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
          Accept: 'application/json',
        },
        body: JSON.stringify({
          configuration_ids: configurationIds,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 'success') {
          this.showSuccessMessage(data.message)
          this.updatePositionNumbers()
        } else {
          throw new Error(data.message)
        }
      })
      .catch((error) => {
        console.error('Error updating configuration order:', error)
        this.showErrorMessage('Erro ao reordenar configurações. A página será recarregada.')
        // Reload page to restore correct order
        setTimeout(() => window.location.reload(), 2000)
      })
  }

  updatePositionNumbers() {
    // Update the priority numbers in the UI
    const priorityElements = this.listTarget.querySelectorAll('.priority-badge')
    priorityElements.forEach((element, index) => {
      // Skip default configuration (it should always show as last priority)
      const card = element.closest('.configuration-card')
      const isDefault = card.dataset.isDefault === 'true'
      
      if (!isDefault) {
        element.textContent = (index + 1).toString()
      }
    })
  }

  showSuccessMessage(message) {
    this.showFlashMessage(message, 'success')
  }

  showErrorMessage(message) {
    this.showFlashMessage(message, 'error')
  }

  showFlashMessage(message, type) {
    window.showNotification(message, type)
  }
}